export default __webpack_public_path__ + "a8de8e3ef847fc6c639db77d2f35c0ae.png";